import { USE_DUMMY_DATA } from 'constants/settings'

export default function isAuthenticated() {
  if (USE_DUMMY_DATA) return true
  return !!window.localStorage.getItem('apiToken')
}
